// Dictionary index and word pages
const dict = {
  uk: {
    index: {
      documentTitle: 'Словник англійської мови | Lingvish',
      backHome: 'На головну',
      heading: 'Словник Lingvish',
      subheading: 'Переклад, транскрипція, вимова і приклади з книжок для кожного англійського слова. Зберігайте слова в тематичні модулі та вчіть у зручному темпі.',
      searchPlaceholder: 'Введіть англійське слово…',
      searchHint: 'Натисніть Enter, щоб перейти до сторінки слова',
      allLevels: 'Всі рівні',
      loading: 'Завантаження…',
      noResults: 'Немає слів за запитом. Натисніть Enter, щоб додати слово в словник.',
      emptyDictionary: 'Словник поки порожній.',
    },
    word: {
      documentTitleSuffix: 'Словник Lingvish',
      loginToSave: 'Увійдіть, щоб зберігати слова у свій словник',
      loadError: 'Не вдалося завантажити слово',
      addError: 'Не вдалося додати',
      addedToMyWords: 'Додано в модуль «Мої слова»',
      alreadyInDictionary: 'Слово вже у словнику',
      loading: 'Завантаження…',
      notFoundInDictionary: 'Такого слова поки нема у словнику.',
      backToDictionary: '← До словника',
      listenPronunciation: 'Прослухати вимову ({{label}})',
      listen: 'Прослухати {{label}}',
      listenSentence: 'Прослухати речення',
      cefrUndefined: 'рівень не визначено',
      cefrUndefinedTitle: 'Рівень CEFR цього слова ще не визначено',
      addToVocabulary: 'Додати в мій словник',
      adding: 'Додаємо…',
      sectionTranslation: 'Переклад',
      sectionUsageExamples: 'Приклади вживання',
      sectionVerbForm: 'Форма дієслова',
      sectionVerbForms: 'Форми дієслова',
      sectionBookExamples: 'Приклади з книжок',
      sectionMeaning: 'Значення (English)',
      adjectiveFormsNote: 'Форми прикметника: чоловічий, жіночий, середній рід, множина.',
      singleTranslationNote: 'Слово має один основний переклад. Різні відтінки значення дивись у розділі «Значення».',
      verbFormMention: 'Слово {{word}} також вживається як форма дієслова',
      verbFormMentionPre: 'Слово ',
      verbFormMentionPost: ' також вживається як форма дієслова',
      verbFormMeaningsNote: 'Значення дієслова дивись у розділі «Значення» нижче (позначені як «дієслово»).',
      verbFormsAutoNote: 'Форми згенеровані автоматично як для правильного дієслова. Якщо це неправильне дієслово — форми можуть бути некоректні.',
      verbFormBase: 'Base',
      verbFormPast: 'Past',
      verbFormPastParticiple: 'Past Participle',
      verbFormIng: '-ing',
      verbFormThirdPerson: '3rd person',
      fromBook: 'з книги',
      chapter: 'розділ {{n}}',
      partsOfSpeech: {
        noun: 'іменник',
        verb: 'дієслово',
        adjective: 'прикметник',
        adverb: 'прислівник',
        pronoun: 'займенник',
        preposition: 'прийменник',
        conjunction: 'сполучник',
        interjection: 'вигук',
        determiner: 'детермінатив',
      },
      formTypeIng: '-ing form (gerund / present participle)',
      formTypeEd: 'past simple / past participle',
    },
  },
  en: {
    index: {
      documentTitle: 'English Dictionary | Lingvish',
      backHome: 'Back to home',
      heading: 'Lingvish Dictionary',
      subheading: 'Translation, transcription, pronunciation, and examples from books for every English word. Save words to themed modules and learn at your own pace.',
      searchPlaceholder: 'Enter an English word…',
      searchHint: 'Press Enter to go to the word page',
      allLevels: 'All levels',
      loading: 'Loading…',
      noResults: 'No words match your query. Press Enter to add the word to the dictionary.',
      emptyDictionary: 'The dictionary is empty for now.',
    },
    word: {
      documentTitleSuffix: 'Lingvish Dictionary',
      loginToSave: 'Sign in to save words to your dictionary',
      loadError: 'Failed to load the word',
      addError: 'Failed to add',
      addedToMyWords: 'Added to the "My Words" module',
      alreadyInDictionary: 'The word is already in your dictionary',
      loading: 'Loading…',
      notFoundInDictionary: 'This word is not in the dictionary yet.',
      backToDictionary: '← Back to dictionary',
      listenPronunciation: 'Listen to pronunciation ({{label}})',
      listen: 'Listen {{label}}',
      listenSentence: 'Listen to sentence',
      cefrUndefined: 'level not set',
      cefrUndefinedTitle: 'The CEFR level for this word has not been set yet',
      addToVocabulary: 'Add to my dictionary',
      adding: 'Adding…',
      sectionTranslation: 'Translation',
      sectionUsageExamples: 'Usage examples',
      sectionVerbForm: 'Verb form',
      sectionVerbForms: 'Verb forms',
      sectionBookExamples: 'Examples from books',
      sectionMeaning: 'Meaning (English)',
      adjectiveFormsNote: 'Adjective forms: masculine, feminine, neuter, plural.',
      singleTranslationNote: 'The word has one main translation. See "Meaning" for shades of meaning.',
      verbFormMention: 'The word {{word}} is also used as a form of the verb',
      verbFormMentionPre: 'The word ',
      verbFormMentionPost: ' is also used as a form of the verb',
      verbFormMeaningsNote: 'See verb meanings in the "Meaning" section below (marked as "verb").',
      verbFormsAutoNote: 'Forms are auto-generated as for a regular verb. If this is an irregular verb, the forms may be inaccurate.',
      verbFormBase: 'Base',
      verbFormPast: 'Past',
      verbFormPastParticiple: 'Past Participle',
      verbFormIng: '-ing',
      verbFormThirdPerson: '3rd person',
      fromBook: 'from the book',
      chapter: 'chapter {{n}}',
      partsOfSpeech: {
        noun: 'noun',
        verb: 'verb',
        adjective: 'adjective',
        adverb: 'adverb',
        pronoun: 'pronoun',
        preposition: 'preposition',
        conjunction: 'conjunction',
        interjection: 'interjection',
        determiner: 'determiner',
      },
      formTypeIng: '-ing form (gerund / present participle)',
      formTypeEd: 'past simple / past participle',
    },
  },
};

export default dict;
